import { parseISO, format, isValid, addHours } from 'date-fns';

import config from '../../config';

const dateWithoutTZFormat = 'yyyy-MM-dd HH:mm:ss';

const dateFormatterWithoutModifyTime = (date, dateFormat = config.DATE_FORMAT) => {
  if (!date || !date.length) {
    return '';
  }

  const parsedDate = parseISO(date);

  if (!isValid(parsedDate)) {
    return date;
  }

  const adjustedDate = addHours(parsedDate, 7);

  return format(adjustedDate, dateFormat);
};

export default dateFormatterWithoutModifyTime;
